import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Toast from '../components/Toast.vue';
// import Web3 from 'web3'
import {
  holeAddressList,
  parseWithUnit,
  solTokenProgram,
  sol2022TokenProgram,
} from '../utils';
import { TP_FORWARD_DOMAIN, TP_SERVER_DOMAIN } from '../utils/config';
import explorer from '../mixins/explorer';
import { reqTokenBatch, reqTokenSecurityByGroup } from '../api';
export const GlobalMixins = {
  mixins: [explorer],
  data() {
    return {
      cancelTokenSource: null,
      isRequestPending: false,
      pollingRateRequestCount: 0,
      transfer_hook_address: [],
      metadata_upgrade_authority_address: [],
      address: '',
      toastTitleObj: {},
      tokenInfo: null,
      holdersPercent: 0,
      lpHoldersPercent: 0,
      lockedPercent: 0,
      isToast: false,
      isLoading: false,
      isDataError: false,
      isCopyContract: false,
      isHoleAddress: false,
      tokenIcon: '',
      symbol: '',
      name: '',
      showAddress: '',

      // tradeList: [],
      // contractList: [],
      // taxList: [],
      chainList: [
        {
          icon: require('../assets/chain-icon/01.png'),
          blockchain_id: 1,
          label: 'Ethereum',
          ns: 'ethereum',
          chain_id: '1',
        },
        {
          icon: `https://hk.tpstatic.net/token/tokenpocket-1739169736992.png`,
          blockchain_id: 12,
          label: 'BNB Chain',
          ns: 'ethereum',
          chain_id: '56',
        },
        {
          icon: 'https://hk.tpstatic.net/token/tokenpocket-1721740965555.png',
          blockchain_id: 27,
          label: 'Solana',
          ns: 'solana',
          chain_id: '1',
        },
        {
          icon: require('../assets/chain-icon/base.png'),
          blockchain_id: 51,
          label: 'Base',
          ns: 'ethereum',
          chain_id: '8453',
        },
        {
          icon: require('../assets/chain-icon/08.png'),
          blockchain_id: 24,
          label: 'Arbitrum',
          ns: 'ethereum',
          chain_id: '42161',
        },
        {
          icon: require('../assets/chain-icon/05.png'),
          blockchain_id: 18,
          label: 'Polygon',
          ns: 'ethereum',
          chain_id: '137',
        },
        {
          icon: require('../assets/chain-icon/06.png'),
          blockchain_id: 23,
          label: 'Avalanche',
          ns: 'ethereum',
          chain_id: '43114',
        },
        {
          icon: require('../assets/chain-icon/tron.png'),
          blockchain_id: 10,
          label: 'Tron',
          ns: 'tron',
          chain_id: '728126428',
        },
        {
          icon: 'https://hk.tpstatic.net/blockChain/tokenpocket-1763993318281.png',
          blockchain_id: 221,
          label: 'Monad',
          ns: 'ethereum',
          chain_id: '143',
        },
        {
          icon: require('../assets/chain-icon/linea.png'),
          blockchain_id: 50,
          label: 'Linea',
          ns: 'ethereum',
          chain_id: '59144',
        },
        {
          icon: require('../assets/chain-icon/zkSync-Era.png'),
          blockchain_id: 46,
          label: 'zkSync Era',
          ns: 'ethereum',
          chain_id: '324',
        },
        {
          icon: require('../assets/chain-icon/op.png'),
          blockchain_id: 26,
          label: 'Optimism',
          ns: 'ethereum',
          chain_id: '10',
        },
        {
          icon: require('../assets/chain-icon/mantle.png'),
          blockchain_id: 49,
          label: 'Mantle',
          ns: 'ethereum',
          chain_id: '5000',
        },
        {
          icon: require('../assets/chain-icon/Gnosis.png'),
          blockchain_id: 28,
          label: 'Gnosis',
          ns: 'ethereum',
          chain_id: '100',
        },
        {
          icon: 'https://hk.tpstatic.net/token/tokenpocket-1731383685240.png',
          blockchain_id: 211,
          label: 'Unichain',
          ns: 'ethereum',
          chain_id: '130',
        },
        {
          icon: require('../assets/chain-icon/bera.png'),
          blockchain_id: 209,
          label: 'Berachain',
          ns: 'ethereum',
          chain_id: '80094',
        },
        {
          icon: require('../assets/chain-icon/Cronos.png'),
          label: 'Cronos',
          ns: 'ethereum',
          chain_id: '25',
        },
        {
          icon: require('../assets/chain-icon/manta.png'),
          blockchain_id: 58,
          label: 'Manta',
          ns: 'ethereum',
          chain_id: '169',
        },
        {
          icon: 'https://hk.tpstatic.net/blockChain/tokenpocket-1733474667855.png',
          blockchain_id: 207,
          label: 'Sonic',
          ns: 'ethereum',
          chain_id: '146',
        },
        {
          icon: require('../assets/chain-icon/merlin.png'),
          blockchain_id: 64,
          label: 'Merlin',
          ns: 'ethereum',
          chain_id: '4200',
        },
        {
          icon: 'https://hk.tpstatic.net/blockChain/tokenpocket-1756877403779.png',
          blockchain_id: 217,
          label: 'Morph',
          ns: 'ethereum',
          chain_id: '2818',
        },
        {
          icon: 'https://hk.tpstatic.net/blockChain/tokenpocket-1729242113462.png',
          blockchain_id: 202,
          label: 'World Chain',
          ns: 'ethereum',
          chain_id: '480',
        },
        {
          icon: 'https://hk.tpstatic.net/blockChain/tokenpocket-1697524283632.png',
          blockchain_id: 56,
          label: 'Scroll',
          ns: 'ethereum',
          chain_id: '534352',
        },
        {
          icon: require('../assets/chain-icon/blast.png'),
          blockchain_id: 65,
          label: 'Blast',
          ns: 'ethereum',
          chain_id: '81457',
        },
        {
          icon: require('../assets/chain-icon/opBNB.png'),
          blockchain_id: 52,
          label: 'opBNB',
          ns: 'ethereum',
          chain_id: '204',
        },
        {
          icon: require('../assets/chain-icon/kcc.png'),
          blockchain_id: 35,
          label: 'KCC',
          ns: 'ethereum',
          chain_id: '321',
        },
        {
          icon: 'https://hk.tpstatic.net/blockChain/tokenpocket-1716888390785.png',
          blockchain_id: 70,
          label: 'Mint',
          ns: 'ethereum',
          chain_id: '185',
        },
        {
          icon: require('../assets/chain-icon/Bitlayer.png'),
          blockchain_id: 66,
          label: 'Bitlayer',
          ns: 'ethereum',
          chain_id: '200901',
        },
        {
          icon: 'https://hk.tpstatic.net/blockChain/tokenpocket-1713324830442.png',
          blockchain_id: 67,
          label: 'X Layer',
          ns: 'ethereum',
          chain_id: '196',
        },
        {
          icon: require('../assets/chain-icon/ZKFair.png'),
          blockchain_id: 57,
          label: 'ZKFair',
          ns: 'ethereum',
          chain_id: '42766',
        },
        {
          icon: 'https://hk.tpstatic.net/blockChain/tokenpocket-1752028737530.png',
          blockchain_id: 214,
          label: 'HashKey Chain',
          ns: 'ethereum',
          chain_id: '177',
        },
        {
          icon: 'https://hk.tpstatic.net/blockChain/tokenpocket-1761813656077.png',
          blockchain_id: 220,
          label: 'Jovay Mainnet',
          ns: 'ethereum',
          chain_id: '5734951',
        },

        {
          icon: 'https://tp-upload.cdn.bcebos.com/blockChain/tokenpocket-1758858476312.png',
          blockchain_id: 218,
          label: 'Plasma',
          ns: 'ethereum',
          chain_id: '9745',
        },
        // {
        //   icon: 'https://hk.tpstatic.net/token/tokenpocket-1764915177489.png',
        //   blockchain_id: 48,
        //   label: 'SUI',
        //   ns: 'sui',
        //   chain_id: '897796746',
        // },
        // {
        //   icon: 'https://tp-upload.cdn.bcebos.com/blockChain/tokenpocket-1717064940425.png',
        //   blockchain_id: 71,
        //   label: 'TON',
        //   ns: 'ton',
        //   chain_id: '-239',
        // },
        {
          icon: require('../assets/chain-icon/07.png'),
          blockchain_id: 25,
          label: 'Fantom',
          ns: 'ethereum',
          chain_id: '250',
        },
        {
          icon: require('../assets/chain-icon/03.png'),
          blockchain_id: 15,
          label: 'HECO',
          ns: 'ethereum',
          chain_id: '128',
        },
        {
          icon: require('../assets/chain-icon/04.png'),
          blockchain_id: 20,
          label: 'OKExChain',
          ns: 'ethereum',
          chain_id: '66',
        },
        {
          icon: require('../assets/chain-icon/10.png'),
          blockchain_id: 33,
          label: 'Harmony',
          ns: 'ethereum',
          chain_id: '1666600000',
        },
        {
          icon: require('../assets/chain-icon/fon.png'),
          label: 'Fon',
          ns: 'ethereum',
          chain_id: '201022',
        },
        {
          icon: require('../assets/chain-icon/ethw.png'),
          label: 'ETHW',
          ns: 'ethereum',
          chain_id: '10001',
        },
      ],
    };
  },
  components: { Loading, Toast },

  computed: {
    isSol() {
      if (
        (this.chainData &&
          this.chainData.ns === 'solana' &&
          this.chainData.chain_id === '1') ||
        this.blockchain_id == 27
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    /** 获取代币的状态 */
    async getTokenStatus(address, blockchain_id, bl_symbol) {
      try {
        const response = await fetch(
          `${TP_SERVER_DOMAIN}/v1/token?blockchain_id=${blockchain_id}&bl_symbol=${bl_symbol}&address=${address}`,
        );
        const res = await response.json();
        if (res.result === 0 && res.data) {
          this.tokenIcon = res.data.icon_url;
          // const obj = {
          //   label: 'trade_token_status_text1',
          //   status: 2,
          // };
          // if (res.data.token_status === 2 || res.data.token_status === 4) {
          //   this.tradeList.unshift(obj);
          // }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getTokenBatch(address, blockchain_id) {
      this.tokenIcon = '';
      this.symbol = '';
      this.name = '';
      this.showAddress = '';
      if (!address || !blockchain_id) {
        return;
      }
      const data = {
        blockchain_id,
        token_list: [{ address }],
      }
      reqTokenBatch(data).then((res) => {
        if (res.result === 0 && res.data && res.data.length) {
          const { icon_url, symbol, name, address } = res.data[0] || {};
          this.tokenIcon = icon_url;
          this.symbol = symbol;
          this.name = name;
          this.showAddress = address;
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    onCopy(text, flag) {
      this.toastTitleObj = {};
      this.$copyText(text);
      if (flag) {
        this.isToast = true;
        this.isCopyContract = true;
      } else {
        if (!this.isToast) {
          this.isToast = true;
          setTimeout(() => {
            this.isToast = false;
            this.isCopyContract = false;
          }, 1500);
        }
      }
    },
    closeToast() {
      this.isToast = false;
      this.isCopyContract = false;
    },
    // 判断一个地址是否是合约
    async getCode(address, node, chain_id) {
      // console.log('address', address);
      // console.log('node', node);
      // console.log('chain_id', chain_id);
      let data = {};
      let url = node;
      if (chain_id == '728126428') {
        data = {
          value: address,
          visible: true,
        };
        url += '/wallet/getcontract';
      } else {
        data = {
          id: 1,
          jsonrpc: '2.0',
          method: 'eth_getCode',
          params: [address, 'latest'],
        };
      }
      try {
        const response = await fetch(url, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });
        const res = await response.json();
        if ((res.result && res.result.length > 5) || res) {
          return true;
        } else {
          this.isLoading = false;
          return false;
        }
      } catch (error) {
        this.isLoading = false;
        // console.log('error', error)
        return false;
      }
    },
    async tokenSecurity(address, blockchain_id, chainData, bl_symbol) {
      this.tokenInfo = null;
      this.isLoading = true;
      this.holdersPercent = 0;
      this.lpHoldersPercent = 0;
      this.lockedPercent = 0;
      let address1 = address.trim();
      if (blockchain_id != 10 || blockchain_id != 27) {
        address1 = address1.toLowerCase();
      }
      try {
        let res = '';
        if (chainData.ns && chainData.chain_id) {
          res = await reqTokenSecurityByGroup({ address: address1, ns: chainData.ns, chain_id: chainData.chain_id, bl_symbol  });
        } else {
          res = await reqTokenSecurityByGroup({ address: address1, blockchain_id });
        }
        if (res.result === 0 && res.data !== null) {
          let data = res.data;
          data.address = this.address;
          if ('owner_address' in data) {
            data.owner_address = data.owner_address.trim();
          }
          if (this.isSol) {
            // throw new Error("222");
            this.initSolData(data);
          } else {
            this.initData(data);
          }
          clearInterval(this.pollingInterval);
        } else {
          // this.pollingRateRequestCount = 0
          if (this.pollingRateRequestCount === 5) {
            clearInterval(this.pollingInterval);
            this.isDataError = true;
            this.isLoading = false;
            console.log('isContract', this.isContract);
            return;
          }
          // this.pollingRateRequest(address, blockchain_id, chainData);
          // throw new Error('error');
        }
      } catch (error) {
        console.log('出错了', error);
        this.isDataError = true;
        this.isLoading = false;
      }
    },
    pollingRateRequest(address, blockchain_id, chainData) {
      clearInterval(this.pollingInterval); // 先清除之前的轮询
      // 开始轮询
      this.pollingInterval = setInterval(() => {
        // console.log('定时器到了发起请求');
        this.pollingRateRequestCount += 1;
        this.tokenSecurity(address, blockchain_id, chainData);
      }, 1000);
    },
    initSolData(data) {
      if (data.holders && Array.isArray(data.holders)) {
        data.holders.forEach((el) => {
          el.address = el.account;
          this.holdersPercent += Number(el.percent) * 100;
        });
        if (this.holdersPercent > 100) {
          this.holdersPercent = 100;
        }
      }
      if (data.lp_holders && Array.isArray(data.lp_holders)) {
        data.lp_holders.forEach((el) => {
          el.address = el.account;
          this.lpHoldersPercent += Number(el.percent) * 100;
          if (el.is_locked) {
            this.lockedPercent += Number(el.percent) * 100;
          }
        });
        if (this.lpHoldersPercent > 100) {
          this.lpHoldersPercent = 100;
        }
        if (this.lockedPercent > 100) {
          this.lockedPercent = 100;
        }
      }
      if (solTokenProgram.indexOf(data.owner_address) > -1) {
        data.solTokenProgram = this.$t('SOL.ownerProgram_1');
      }
      if (sol2022TokenProgram.indexOf(data.owner_address) > -1) {
        data.sol2022TokenProgram = this.$t('SOL.ownerProgram_2');
      }
      data.is_scheduled_fee_rate =
        data.transfer_fee?.scheduled_fee_rate?.length || false;
      data.buy_tax = data.transfer_fee?.current_fee_rate?.fee_rate || '';
      // data.sell_tax = data.transfer_fee?.current_fee_rate?.maximum_fee || undefined
      // data.buy_tax = '0.2'
      // data.sell_tax = '0.6'
      if (data.buy_tax) {
        data.buy_tax = (Math.floor(data.buy_tax) / 100).toFixed(2);
      } else {
        // data.buy_tax = this.$t('unknown_tax')
        data.buy_tax = 'unknown_tax';
        data.unknown_buy_tax = true;
      }
      // if (data.sell_tax) {
      //   data.sell_tax = parseWithUnit(data.sell_tax / Math.pow(10, 9))
      // }
      // console.log('initSolData', window.structuredClone(data));
      this.tokenInfo = data || {};
      this.isLoading = false;
    },
    initData(data) {
      // console.log('data', data);
      this.tokenInfo = data || {};
      // if (!this.tokenInfo.creator_address) {
      //   throw new Error('error')
      // }
      if (this.tokenInfo.holders && this.tokenInfo.holders.length) {
        this.tokenInfo.holders.forEach((el) => {
          this.holdersPercent += Number(el.percent) * 100;
        });
        if (this.holdersPercent > 100) {
          this.holdersPercent = 100;
        }
        // this.holdersPercent = 19
      }
      if (this.tokenInfo.lp_holders && this.tokenInfo.lp_holders.length) {
        this.tokenInfo.lp_holders.forEach((el) => {
          this.lpHoldersPercent += Number(el.percent) * 100;
          if (el.is_locked) {
            this.lockedPercent += Number(el.percent) * 100;
          }
        });
        if (this.lpHoldersPercent > 100) {
          this.lpHoldersPercent = 100;
        }
        if (this.lockedPercent > 100) {
          this.lockedPercent = 100;
        }
      }
      // this.lockedPercent = 19
      this.isLoading = false;
    },
  },
};
